<section class="sh-dialog__content">
    <p>{{ warningMsg }}</p>
    <div *ngFor="let validityObject of validityObjects">
        <div>
            <p class="sh-clear-margin-bottom">
                <sh-html-parser [message]="validityObject.message"></sh-html-parser>
            </p>
            <sh-action-item [item]="validityObject.link"></sh-action-item>
        </div>
    </div>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button--secondary sh-action-group__item" (click)="cancel()">{{config.data.cancel}}</button>
    </div>
</footer>
